import React from "react";
import styled, { ThemeProvider } from "styled-components";

interface imgInput {
    srcImg?: string;
}
const StyledContainer = styled.input<imgInput>`
    display: flex;
    height: 5vw;
    justify-content: space-between;
    align-content: center;
    align-items: center;
    border-radius: 2vw;
    background: ${(props) => `linear-gradient(
        45deg, ${props.theme.primary.main}, ${props.theme.secondary.main}
    )`};
    border: 1px gray solid;

    @media (max-width: 800px) {
        min-height: 11vw;
        min-width: 55vw;
        margin: 1vw;
    }

    background: ${(props) => `#ccc url('${props.srcImg}') no-repeat top left;`};
    padding-left: 8vw;
    height: 7vw;
    font-size: 2vw;
    padding-right: 1vw;
`;

const theme = {
    main: "royalblue",
    border: {
        cool: "black",
    },
    primary: {
        main: "#553C8B",
    },
    secondary: {
        main: "#F2F4D1",
    },
};

interface IButtonImage {
    text?: string;
    srcImg: string;
    onClick?: Function;
}

const ImageButton: React.FC<IButtonImage> = ({ text, srcImg, onClick }) => (
    <ThemeProvider theme={theme}>
        <StyledContainer
            type={"image"}
            srcImg={srcImg}
            onClick={() => onClick}
            value={text}
        />
    </ThemeProvider>
);

export default ImageButton;
